import { Injectable } from '@angular/core'
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router'
import { BehaviorSubject, Observable } from 'rxjs'
import { filter } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  visible$: BehaviorSubject<boolean>

  constructor(private _router: Router) {
    this._init()
  }

  get visible(): Observable<any> {
    return this.visible$.asObservable()
  }

  show(): void {
    this.visible$.next(true)
  }

  hide(): void {
    this.visible$.next(false)
  }

  private _init(): void {
    this.visible$ = new BehaviorSubject(false)

    // Subscribe to the router events to show/hide the loading bar
    this._router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      this.show()
    })

    this._router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd ||
            event instanceof NavigationError ||
            event instanceof NavigationCancel,
        ),
      )
      .subscribe(() => {
        this.hide()
      })
  }
}
